module.exports = __webpack_public_path__ + "app-static/img/13.37723a83.png";